
//Occupation Search and Selection (SOC)


class OccupationSkillsPicker extends React.Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeDebounced = this.handleInputChangeDebounced.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.getSelection = this.getSelection.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.state = {
            min_importance: 2.5,
            skills: this.props.occupation.occupation_skills.filter(
                        (ksa) => (ksa.irrelevant) ? false : true
                    ).map(function(ksa,index){
                        let element = ksa;
                        element.checked = false;
                        return element;
                    }),
            title: "Skills for " + this.props.occupation.title,
            description: "These are skills that specifically need improvement.",
            target_date: "",
            saving: false
        };
        this.dateRef = React.createRef();
        this.skillsPickerRef = React.createRef();
    }

    componentDidMount() {
        // console.info('OccupationSkillsPicker mounted')
        let pickerFrom = new Pikaday({
            field: this.dateRef.current,
            defaultDate: new Date()
        });
        this.setState({
            datepicker: true
        });
        //tooltips binding...jquery plugin :(
        $('[data-popover="tooltip"]',this.skillsPickerRef.current).tooltip();
    }

    componentDidUpdate() {
        $('[data-popover="tooltip"]',this.skillsPickerRef.current).tooltip();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    handleInputChangeDebounced(event) {
        let _self = this;
        debounce(_self.handleInputChange(event),100).call();
    }

    handleChecked(event) {
        const target = event.target;
        const checked = target.checked;
        const value = target.value;
        const name = target.name;
        //for loop for speed here
        for(var i = 0; i < this.state.skills.length; i++){
            if(this.state.skills[i].skill.id == value) {

                // Make a shallow copy of the items
                let items = [...this.state.skills];
                // Make a shallow copy of the item you want to mutate
                let item = {...items[i]};
                // Replace the property you're intested in
                item.checked = checked;
                // Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
                items[i] = item;
                // Set the state to our new copy
                this.setState({
                    skills: items
                });

                break;
            }
        }
    }

    handleSave() {
        let _self = this;
        let missing = 0;

        this.state.saving = true;

        $(this.skillsPickerRef.current).find(":input[required]").each(function(){
            if( $(this).val().length == 0) {
                missing++;
                alertify.warning( $("label[for=" + $(this).attr('id') + "]").text() + " is Required");
            }
        });

        let skills = this.getSelection().map(function(element){
            return {
                skill: element.skill.name,
                level: element.level
            }
        });

        if(skills.length == 0){
            missing++;
            alertify.warning("You must select at least one skill.");
        }

        if(missing == 0) {
            //form serialize doesn't work well in this scenario, easiest to manually build
            var oData = {
                "title": this.state.title,
                "description": this.state.description,
                "target_date": new Date( $('#target_date').val() ).toJSON(), //the plugin isn't triggering on change, so state is always null. temp fix
                "skills": skills
            }

            alertLoading();
            httpPost(this.props.post, oData).then(
                function(value){
                    response = JSON.parse(value);
                    alertify.closeLogOnClick(true).success('Goal Created');
                    setTimeout(function(){ window.location = _self.props.redirect; }, 700);
                })
            .catch(
                function(reason) {
                    removeLoading();
                    _self.state.saving = false;
                    console.error(JSON.parse(reason));
                    alertify.error('Unable to Create Goal');
                });
        } else {
            this.state.saving = false;
        }

    }

    handleBrowse() {
        OccupationPickerActions.changeBrowseMode(true);
    }

    getSelection() {
        return this.state.skills.filter( (ksa) => ksa.checked );
    }

    render() {
        return (
            <div className="text--left" ref={this.skillsPickerRef}>
                <div className="row">
                    <div className="column-6 text--left">
                        <button onClick={this.handleBrowse} className="button--flat button--sm button--skinny" aria-label="Go back and pick a new occupation"><Icon classes="icon-arrow-left icon--neutral" /> Look Up a New Occupation</button>
                    </div>
                    <div className="column-6 text--right" role="status">
                        {!this.state.saving && (
                            <span>Matching occupation skills to choose from: <b>{this.state.skills.length}</b></span>
                        )}
                        {this.state.saving && (
                            <span>Saving goal...</span>
                        )}
                    </div>
                </div>

                <h3 className="h4 text--loosetop text--center">Which Job-Related Skills Do You Want to Track?</h3>
                <p className="text--center">You must select at least one. <span role="status" aria-live="polite">{this.getSelection().length} selected.</span></p>

                <div className="form--inline text--center text--loosebottom">
                    <div className="input-group">
                        <label htmlFor="min_importance" className="input-prefix bg--secondary text--reversed">How Important Should They Be?</label>
                        <span> Less Important </span>
                        <input name="min_importance" aria-label="Filter job skills by their importance to the role. Higher means it's more important." id="min_importance" type="range" min="1" max="5" step="0.1" defaultValue="2.5" onChange={this.handleInputChangeDebounced} />
                        <span> Extremely Important </span>
                    </div>
                </div>
                <p className="text--center text--loosebottom"><a href="#goal_inputs">Jump to goal description entry.</a></p>

                <OccupationSkillsPickerKSAs items={this.state.skills} min_importance={this.state.min_importance} handleChecked={this.handleChecked} />

                <div className="row text--loosetop">
                    <div className="column-6 column-plus3">
                        <a id="goal_inputs" />
                        <label htmlFor="title">Goal Title</label>
                        <input type="text" required name="title" id="title" defaultValue={this.state.title} onChange={this.handleInputChange} />
                        <label htmlFor="description">Why is it important?</label>
                        <textarea required name="description" id="description" rows="4" defaultValue={this.state.description} onChange={this.handleInputChange}></textarea>
                        <h3 className="h5">What is your target date?</h3>
                        <div className="input-group">
                            <label htmlFor="target_date" className="input-prefix"><i className="icon-calendar" title="Target Date"></i> Target</label>
                            <input required type="text" id="target_date" name="target_date" ref={this.dateRef} defaultValue={this.state.target_date} onChange={this.handleInputChange} />
                        </div>

                        <div className="text--loosetop">
                        {!this.state.saving && (
                            <button onClick={this.handleSave} className="button--success button--full"><i className="icon-check"></i> Save Career Skills Goal</button>
                        )}
                        {this.state.saving && (
                            <button onClick={this.handleSave} className="button--success button--full" disabled><i className="icon-check"></i> Saving...</button>
                        )}
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}


class OccupationSkillsPickerKSAs extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const threshold = this.props.min_importance;
        const ksas = this.props.items.filter(
            (ksa,index) => (ksa.importance >= threshold) ? true : false
        ).map(
            (ksa,index) => <OccupationSkillsPickerKSA key={"ksa_item_" + index} ksa={ksa} handleChecked={this.props.handleChecked} />
        );

        return (
            <ul className="collection collection--ksa" aria-live="polite" aria-atomic="true">
                {ksas}
                {ksas.length == 0 && (
                    <li className="collection-item text--center text--xl" style={{width:'100%'}}>No Matching Skills Found</li>
                )}
            </ul>
        );

    }
}

class OccupationSkillsPickerKSA extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const importance_percent_int = parseInt((this.props.ksa.importance / 5) * 100);
        const ticks = this.props.ksa.skill.levels.map(
            (level,index) => <OccupationSkillsPickerKSATick key={"ksa_tick_" + index} level={level} />
        );
        const progressStyle = {width: importance_percent_int + "%"};
        return (
            <li className="collection-item row">
                <div className="column-7">
                    <label className="ksa-name"><input type="checkbox" value={this.props.ksa.skill.id} name={this.props.ksa.skill.name} onChange={this.props.handleChecked} defaultChecked={this.props.ksa.checked} /> {this.props.ksa.skill.name}</label>
                    <div className="text--center">
                        <div className="progress ksa-importance" role="graphics-symbol" aria-label={"Importance Rated " + this.props.ksa.importance + "/5"} title={"Importance Rated " + this.props.ksa.importance + "/5"} data-popover="tooltip">
                            <span style={progressStyle}></span>
                        </div>
                        <span className="flag flag--faint flag--sm flag--badged" aria-hidden="true">Importance</span>
                    </div>

                </div>
                <div className="column-5">
                    <label className="text--center ksa-level-label">Level Required</label>
                    <div className="ksa-level" aria-label={`Skill importance is rated ${this.props.ksa.level} out of 7 for this occupation`}>
                        <input type="range" min="0" max="7" step="0.01" name="level" value={this.props.ksa.level} title={this.props.ksa.level + " out of 7"} disabled />
                        <ul className="ksa-level-anchors" role="graphics-annotation" aria-label={`Practical ${this.props.ksa.name} examples at different levels`}>
                            {ticks}
                        </ul>
                    </div>

                </div>
            </li>
        );

    }
}

class OccupationSkillsPickerKSATick extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const offset_percent = roundedDecimal((this.props.level.value / 7) * 100, 1);
        const tickStyle = {left: offset_percent + "%"};
        return (
            <li role="graphics-tick" data-value={this.props.level.value} style={tickStyle} data-original-title={this.props.level.description} data-popover="tooltip" data-label={`${this.props.level.description} is rated ${this.props.level.value}`}>
                <span><Icon classes="icon-info-circle icon--larger" title={this.props.level.description} /></span>
            </li>
        );

    }
}
